module.exports = __webpack_public_path__ + "static/media/money-bags-fr.ed31003f.png";